import type { ModalProps } from "antd";
import { useCallback } from "react";
import { useLogin } from "..";
import HBButton from "../../HBButton";
import HBModal from "../../HBModal";
import ModalWrap from "../../HBModal/ModalWrap";
import styles from "./index.module.less";

interface LogoutConfirmModalProps extends Omit<ModalProps, "title" | "footer"> {
  onOk?: () => void;
  onCancel?: () => void;
  title?: string;
  content?: string;
  okText?: string;
  cancelText?: string;
  closable?: boolean;
  width?: number;
}

/**
 * 退出登录确认弹窗组件
 */
function LogoutConfirmModal({
  onOk,
  onCancel,
  title = "是否退出登录?",
  content = "您当前的稿定账号、花瓣账号已合并为一个账号，退出登录后，稿定、花瓣、稿定AI站点均会退登。",
  okText = "退出",
  cancelText = "取消",
  closable = true,
  width = 400,
  ...props
}: LogoutConfirmModalProps) {
  const { logout } = useLogin();
  const handleOk = useCallback(() => {
    logout();
    onOk?.();
  }, [logout, onOk]);

  const handleCancel = useCallback(() => {
    onCancel?.();
  }, [onCancel]);

  return (
    <HBModal
      {...props}
      title={null}
      footer={null}
      closable={closable}
      width={width}
      onCancel={handleCancel}
      className={styles.modal}
    >
      <div className={styles.container}>
        <div className={styles.title}>{title}</div>
        <div className={styles.content}>{content}</div>
        <div className={styles.footer}>
          <HBButton onClick={handleCancel} className={styles.cancelBtn}>
            {cancelText}
          </HBButton>
          <HBButton
            type="primary"
            danger
            onClick={handleOk}
            className={styles.okBtn}
            active
          >
            {okText}
          </HBButton>
        </div>
      </div>
    </HBModal>
  );
}

const LogoutConfirmDialog = ModalWrap(LogoutConfirmModal, { unique: true });

export default LogoutConfirmDialog;
